import { useTranslation } from "react-i18next";
import Select from "../Select";
import { weekdays, type WeekdaySelectProps } from "./types";

function WeekdaySelect({ placeholder, ...props }: WeekdaySelectProps) {
    const { t } = useTranslation();

    return (
        <Select placeholder={placeholder ?? t("select-days")} {...props}>
            {weekdays.map((day) => (
                <Select.Item key={day} value={day}>
                    {t(day)}
                </Select.Item>
            ))}
        </Select>
    );
}

export default WeekdaySelect;
